<template>
  <b-row class="responsavel-row">
    <b-col>
      <cabecalho-repeticao
        titulo="Adicione os responsáveis por departamento"
        @apply="adicionarItem"
        @remove="removerItem"
      />
      <b-row style="margin-top: 1.3rem;">
        <b-col
          cols="3"
          class="pr-0"
        >
          <departamento-select
            v-model="valueInner.departamento"
            :invalido="valueInner.erro && valueInner.erro['departamento']"
            :filtro-adicional="removerDepsRepetidos"
            @input="limpaUsuarios()"
          />
        </b-col>
        <b-col
          cols="3"
          class="pr-0 pl-50"
        >
          <b-form-group
            :label="'Dia de Início da Cobrança'"
          >
            <b-select
              v-model="valueInner.diaCobrancaDocumentos"
              @input="alterarCobrarCada(valueInner)"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index }}</option>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="3"
          class="pr-0 pl-50"
        >
          <b-form-group
            :label="'Intervalo entre Cada Cobrança'"
          >
            <b-select
              v-model="valueInner.cobrarDocumentosCada"
              :disabled="!valueInner.diaCobrancaDocumentos"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index }}</option>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="3"
          class="pr-0 pl-50"
        >
          <div style="display: flex;">
            <div>
              <legend style="font-size: 14px;">
                Dias de Cobrança Múltipla</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                :title="tituloMultiplaCobranca"
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <v-select
            v-model="valueInner.cobrancaMultipla"
            :options="copiaOpcoesCobrancaMultipla"
            multiple
            clearable
            :disabled="!valueInner.diaCobrancaDocumentos"
            @input="escolhidoMultiplaCobranca"
          />
        </b-col>
      </b-row>

      <b-row
        v-if="valueInner.departamento"
        class="mb-2"
      >
        <b-col style="margin-left: 1rem;">
          <tabela-repeticao
            v-model="valueInner.usuariosResponsaveis"
            :colunas="usuarioColunas"
            :validar="validar"
            class="usuarios-responsaveis"
          >
            <template #visualizacao="{slotScope: {valor, key, index}}">
              <span v-if="key === 'usuario'">
                {{ valor.nomeCompleto }}
                <b-badge
                  v-if="!valor.ativo"
                  variant="danger"
                  class="usuario-ativo-badge"
                >Inativo</b-badge>
              </span>
              <b-btn
                v-else-if="key === 'acao'"
                v-b-tooltip.hover.top
                title="Abrir cadastro em nova aba"
                size="sm"
                variant="none"
                style="margin-left: -0.5rem;margin-top: -0.4rem;cursor: pointer;"
                @click="abrirGridUsuario(index)"
              >
                <font-awesome-icon
                  :icon="faExternalLinkAlt"
                  :class="'text-primary'"
                />
              </b-btn>
              <b-form-group
                v-else-if="key === 'isRemetente'"
                class="check-remetente"
              >
                <b-checkbox
                  :checked="valor"
                  :disabled="true"
                >
                  <label style="font-size: 1rem">Remetente de e-mail</label>
                </b-checkbox>
              </b-form-group>
            </template>

            <template #edicao="{slotScope: {item, key}}">
              <validation-provider
                v-if="key === 'usuario'"
                #default="{ errors }"
                name="'usuarioResponsavel'"
                :rules="!item[key] && valueInner.usuariosResponsaveis.length <= 1 ? 'required' : ''"
              >
                <usuario-interno-select
                  v-model="item[key]"
                  :label="''"
                  :invalido="item.erro && item.erro[key] || errors.length > 0"
                  :departamento="valueInner.departamento ? valueInner.departamento.id : 0"
                  :filtro-adicional="removerUsuarioDuplicado"
                  :placeholder="'Selecione o usuário'"
                  class="usuario-interno-select"
                  :ignorar-primeiro-acesso="true"
                  @input="primeiroRemetente"
                />
              </validation-provider>
              <b-btn
                v-else-if="key === 'acao'"
                v-b-tooltip.hover.top
                title="Abrir cadastro em nova aba"
                size="sm"
                variant="none"
                style="margin-left: -0.5rem;margin-top: -0.4rem;cursor: pointer;"
                @click="abrirGridUsuarioInterno(item['usuario'])"
              >
                <font-awesome-icon
                  :icon="faExternalLinkAlt"
                  :class="'text-primary'"
                />
              </b-btn>
              <b-form-group
                v-else-if="key === 'isRemetente'"
                class="check-remetente"
              >
                <b-checkbox
                  id="checkboxRemetente"
                  v-model="item[key]"
                  :disabled="valueInner.usuariosResponsaveis.length >= 1 && item.usuario === undefined"
                  @change="alterarRemetente(item)"
                >
                  <label style="font-size: 1rem">Remetente de e-mail</label>
                </b-checkbox>
              </b-form-group>
            </template>
          </tabela-repeticao>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.usuarios-responsaveis {
    th {
      padding-left: 1%;
      display: none;
    }
}

.usuarios-responsaveis tbody tr td:first-child{
  padding-left: 1%;
  width: 49.8%;
}

.titulo-Cadastro {
  padding-top: .6rem;
  border-bottom: 1px solid #0000006e;
  background-color: #ede6b1;
}

.responsavel-row {
  &:hover {
    background-color: rgba(24, 28, 33, 0.03);
    border-radius: 1px;
  }
}

.check-remetente {
  margin-top: 3.5%;
}

.usuario-ativo-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}
</style>

<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import { ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faExternalLinkAlt, faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'

export default {
  name: 'ResponsavelDepartamentoRow',
  components: {
    vSelect,
    ValidationProvider,
    FontAwesomeIcon,
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    TabelaRepeticao: () => import('@/shared/components/tabela-repeticao/TabelaRepeticao.vue'),
    UsuarioInternoSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      faExternalLinkAlt,
      faQuestionCircle,
      valueInner: {
        departamento: {},
        diaCobrancaDocumentos: null,
        cobrarDocumentosCada: null,
        cobrancaMultipla: [],
      },
      usuarioColunas: [
        { key: 'usuario', label: 'Usuário Responsável' },
        { key: 'acao', label: '' },
        { key: 'isRemetente', label: '' },
      ],
      opcoesCobrancaMultipla: [],
      copiaOpcoesCobrancaMultipla: [],
      diaCobranca: null,
      tituloMultiplaCobranca: 'Quando configurado datas nesse campo, o sistema realizará a cobrança múltipla dos documentos nas datas configuradas dentro do Mês. Importante: somente será cobrado os documentos marcados como Cobrança Múltipla na aba "Modelos".',
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    for (let index = 1; index <= 31; index += 1) {
      this.opcoesCobrancaMultipla.push(index)
    }
    this.copiaOpcoesCobrancaMultipla = [...this.opcoesCobrancaMultipla]
    this.valueInner = this.value
    if (!this.valueInner.usuariosResponsaveis) {
      this.$set(this.valueInner, 'usuariosResponsaveis', [])
    }

    if (this.valueInner.diaCobrancaDocumentos) {
      this.copiaOpcoesCobrancaMultipla = this.opcoesCobrancaMultipla.filter(fil => fil > this.valueInner.diaCobrancaDocumentos)
    }

    this.diaCobranca = this.valueInner.diaCobrancaDocumentos
  },
  methods: {
    removerDepsRepetidos(deps) {
      const depsExistentes = this.empresa.departamentos.filter(fil => fil.departamento)

      if (depsExistentes && depsExistentes.length > 0) {
        const depsFiltrados = []
        deps.forEach(each => {
          if (!depsExistentes.find(index => index.departamento.id === each.id)) {
            depsFiltrados.push(each)
          }
        })
        return depsFiltrados
      }
      return null
    },
    removerUsuarioDuplicado(usuarios) {
      let usuariosExistentes = this.empresa.departamentos.filter(fil => fil.usuario)
      if (this.valueInner.usuariosResponsaveis && this.valueInner.usuariosResponsaveis.length > 0) {
        usuariosExistentes = this.valueInner.usuariosResponsaveis.filter(fil => fil.usuario)
      }

      if (usuariosExistentes && usuariosExistentes.length > 0) {
        const usuariosFiltrados = []
        usuarios.forEach(each => {
          if (!usuariosExistentes.find(index => index.usuario.id === each.id)) {
            usuariosFiltrados.push(each)
          }
        })
        return usuariosFiltrados
      }
      return null
    },
    validar(item) {
      this.$set(item, 'erro', {})

      if (!item.usuario) {
        this.$set(item.erro, 'usuario', true)
        return false
      }

      const existeRemetente = this.valueInner.usuariosResponsaveis.find(f => f.isRemetente)
      if (!existeRemetente) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deve ter um remetente marcado por departamento',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return false
      }
      return true
    },
    removerItem() {
      this.$emit('remove', this.valueInner)
    },
    adicionarItem() {
      if (this.responsavelDepartamentoValido()) {
        this.$emit('novo', this.valueInner)
      }
    },
    responsavelDepartamentoValido() {
      let valido = true
      this.$set(this.valueInner, 'erro', {})

      if (!this.valueInner.departamento) {
        this.$set(this.valueInner.erro, 'departamento', true)
        valido = false
      }
      return valido
    },
    alterarCobrarCada(item) {
      if (item.diaCobrancaDocumentos !== this.diaCobranca) {
        if (this.valueInner.cobrancaMultipla && this.valueInner.cobrancaMultipla.length > 0) {
          this.valueInner.cobrancaMultipla = []
        }
        this.diaCobranca = item.diaCobrancaDocumentos
        this.copiaOpcoesCobrancaMultipla = this.opcoesCobrancaMultipla.filter(fil => fil > item.diaCobrancaDocumentos)
      }
      if (item.diaCobrancaDocumentos && !item.cobrarDocumentosCada) {
        this.valueInner.cobrarDocumentosCada = 1
      } else if (!item.diaCobrancaDocumentos && item.cobrarDocumentosCada) {
        this.valueInner.cobrarDocumentosCada = null
      }
    },
    primeiroRemetente() {
      if (this.valueInner.usuariosResponsaveis && this.valueInner.usuariosResponsaveis.length === 1) {
        document.getElementById('checkboxRemetente').disabled = false
        document.getElementById('checkboxRemetente').click()
      }
    },
    alterarRemetente(item) {
      const remetenteAtual = this.valueInner.usuariosResponsaveis.find(fin => fin.isRemetente && fin.usuario.id !== item.usuario.id)

      if (remetenteAtual) {
        const index = this.valueInner.usuariosResponsaveis.findIndex(f => f.usuario.id === remetenteAtual.usuario.id)
        this.valueInner.usuariosResponsaveis.splice(index, 1)
        remetenteAtual.isRemetente = false
        this.valueInner.usuariosResponsaveis.splice(index, 0, remetenteAtual)
      }
    },
    limpaUsuarios() {
      this.$set(this.valueInner, 'usuariosResponsaveis', [])
    },
    abrirGridUsuario(index) {
      const user = this.valueInner.usuariosResponsaveis[index]
      if (user && user.usuario) {
        this.abrirGridUsuarioInterno(user.usuario)
      }
    },
    abrirGridUsuarioInterno(value) {
      if (isAdmin()) {
        if (value && value.id > 0) {
          abrirEmNovaGuia('editar-usuario-interno', value.id)
        } else {
          abrirEmNovaGuia('usuariosinternos')
        }
      } else {
        const ability = permitidoAcessarRecurso('usuinterno')
        if (ability) {
          if (value && value.id > 0 && ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-usuario-interno', value.id)
          } else {
            abrirEmNovaGuia('usuariosinternos')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    escolhidoMultiplaCobranca(value) {
      this.valueInner.cobrancaMultipla = value.sort((a, b) => a - b)
    },
  },
}
</script>
